<template>
    <div class="loading" v-if="progress < 100">
        <img src="/img/xj/loading.gif" alt="">
        <p>穿越中 {{progress}}%</p>
    </div>
</template>

<script>
import http from 'axios';

export default {
    data() {
        return {
            progress: 0,
            speed: 700,
            loadingList: [
                'lv2_text_1.png',
                'lv2_text_2.png',
                'lv4_text_1.png',
                'lv4_text_2.png',
                'lv6_text_1.png',
                'template.jpg',
                'btn_redo.png',
                'bgimg.jpg',
                'lv4_snow.png',
                'body.png',
                'btn_bg_active.png',
                'btn_bg.png',
                'btn_chat.png',
                'btn_enter.png',
                'btn_play.gif',
                'btn_question.png',
                'btn_submit.png',
                'chenfankuanzhi.png',
                'choise_bg.png',
                'fankuan_arm.png',
                'fankuan_body.png',
                'fankuan_head.png',
                'fog.png',
                'leve1.png',
                'lu_run.png',
                'lu.png',
                'lv2.png',
                'lv4.png',
                'pass.gif',
                'rabbit.png',
                'seal_1.png',
                'seal_2.png',
                'seal_none.png',
                'seal-none.png',
                'seals_box_1.png',
                'seals_box_2.png',
                'snow.png',
                'stone.png',
                'through.png',
                'xue.png'
            ]
        };
    },
    methods: {
        loadImg(url) {
            return new Promise(res => {
                const img = new Image();
                img.src = url;
                img.onload = () => {
                    this.progress = Math.floor(this.progress + (1 / 32 * 80));
                    res();
                };
                img.onerror = () => {
                    res();
                };
            });
        },
        changeProgress() {
            this.progress = this.progress + 1;
            if (this.progress > 99) {
                return;
            }
            setTimeout(() => {
                this.changeProgress();
            }, this.speed);
        }
    },
    created() {
        this.changeProgress();
        const promiseList = this.loadingList.map(item => this.loadImg(`/img/xj/${item}`));
        Promise.all([
            ...promiseList,
            http.get('/font/xj.ttf')
        ]).then(() => {
            this.progress = 100;
        }).catch(() => {
            this.speed = 70;
        });
    }
};
</script>

<style lang="stylus" scoped>
.loading
    position absolute
    size 100%
    z-index 99
    background #363232
    display flex
    flex-direction column
    justify-content center
    align-items center
    img
        size 1.18rem auto
    p
        font-size .28rem
        color #faf0d5
        text-align center
</style>
